export const LOGIN_REQUIRED_TITLE = "Login required"

// Returns the disabled/title prop pair for a button that requires login.
export const loginGuardProps = (isLoggedIn, enabledTitle) => ({
  disabled: !isLoggedIn,
  title: isLoggedIn ? enabledTitle : LOGIN_REQUIRED_TITLE,
})

export const hasPremiumAccess = (user) =>
  !!(user?.admin || user?.unlimited_premium || user?.premium_pass_active || user?.has_premium_credits)

export const hasPremiumPassOrCredits = (user) => !!(user?.premium_pass_active || user?.has_premium_credits)

export const pluralizeDays = (n) => `${n} day${n !== 1 ? "s" : ""}`

// Label for the button that toggles the login/signup forms open and closed.
export const authToggleLabel = (showForms, mode) =>
  showForms ? (mode === "login" ? "Cancel Login" : "Cancel Sign Up") : "Login / Sign Up"
